module.exports = __webpack_public_path__ + "img/790039a.jpg";